import { useTranslateForm } from 'hooks/use-translate-payoff';
import { useAppSelector } from 'hooks/useAppSelector';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useQuote } from 'routes/essential-workspace/hooks/use-quote';
import { selectEssentialValidationFormErrors } from 'state/essential/infos/selectors';

export function QuoteFormErrorMessage({ multiple = false }: { multiple?: boolean }) {
  const { formId } = useQuote();
  const { translateFieldLabel } = useTranslateForm();
  const formErrors = useAppSelector(state => selectEssentialValidationFormErrors(state, formId));

  const translateErrors = useMemo(
    () => formErrors.map(item => translateFieldLabel(item.fields?.[0] || '')),
    [formErrors, translateFieldLabel],
  );

  const errors = multiple ? translateErrors.join(', ') : (translateErrors[0] ?? '');

  return (
    <>
      <FormattedMessage
        id={multiple ? 'sidePanel.quoteStatus.notReady.errors' : 'sidePanel.quoteStatus.notReady.errorSummary'}
        defaultMessage="Add the {errors} to price"
        values={{ errors }}
      />
    </>
  );
}
